import {
  useMemo,
  useState,
  Dispatch,
  ReactNode,
  createContext,
  SetStateAction,
} from "react";

interface Context {
  isTabLoading?: boolean;
  setIsTabLoading?: Dispatch<SetStateAction<boolean>>;
  loadingTab?: string;
  setLoadingTab?: Dispatch<SetStateAction<string>>;
}

export const LoadingContext = createContext<Context>({});

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [isTabLoading, setIsTabLoading] = useState<boolean>(false);
  const [loadingTab, setLoadingTab] = useState<string>("");

  const context: Context = useMemo(
    () => ({ isTabLoading, setIsTabLoading, loadingTab, setLoadingTab }),
    [isTabLoading, setIsTabLoading, loadingTab, setLoadingTab]
  );

  return (
    <LoadingContext.Provider value={context}>
      {children}
    </LoadingContext.Provider>
  );
};
